export default __webpack_public_path__ + "static/media/verifyEmail.299f4497.png";